import * as actions from "./actions";

const initialState = {
	userPermission: null,
	items: [],
	loading: {}
};

const reducer = function(state = initialState, { type, payload }) {
	switch (type) {
		case actions.GET_PERMISSIONS: {
			return {
				...state,
				loading: { getAll: true }
			};
		}
		case actions.GET_PERMISSIONS_SUCCESS: {
			return {
				...state,
				items: payload,
				loading: { getAll: false }
			};
		}
		case actions.GET_PERMISSIONS_ERROR: {
			return {
				...state,
				errors: payload,
				loading: { getAll: false }
			};
		}
		case actions.CREATE_PERMISSION: {
			return {
				...state,
				loading: { create: true }
			};
		}
		case actions.CREATE_PERMISSION_SUCCESS: {
			return {
				...state,
				loading: { create: false }
			};
		}
		case actions.CREATE_PERMISSION_ERROR: {
			return {
				...state,
				errors: payload,
				loading: { create: false }
			};
		}
		case actions.SET_VALUE:
			return {
				...state,
				...payload
			};
		case actions.CLEAR_VALUES:
			return {
				...initialState
			};
		default: {
			return state;
		}
	}
};

export default reducer;
